import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import useBreakpoints from '#client/hooks/useBreakpoints';

import { Link } from './SectionLink.style';

function SectionLink({ text, url, isDisabled = false, trackingProperties = null }) {
  const theme = useTheme();
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  const handleLinkPressed = useLinkPressedCallback({
    elementText: text || 'See all',
    elementAsset: '/s2/icon/arrow-sm-right-outline.svg',
    appPageName: 'active_banking_dashboard',
    ...trackingProperties
  });

  const clickHandler = (event) => {
    if (isDisabled) {
      event.preventDefault(); // Prevent the default navigation behavior
    }
    if (trackingProperties) {
      handleLinkPressed();
    }
  };

  return (
    <Link
      onClick={clickHandler}
      to={url}
    >
      <Text
        color="tertiary"
        component="span"
        size="md"
        weight="medium"
      >
        {text}
      </Text>

      <SharedAsset
        alt=""
        color={theme.palette.text.tertiary}
        src="/s2/icon/arrow-sm-right-outline.svg"
        width={isDesktop ? 24 : 20}
      />
    </Link>
  );
}

SectionLink.propTypes = {
  isDisabled: PropTypes.bool,
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  trackingProperties: PropTypes.shape({})
};

export default SectionLink;
